import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { loginActions } from '../../redux';
import { ApplicationLoading } from '../loading';

class Login extends React.Component{

    componentDidMount() { 
        const { location, history, user } = this.props;
        const token = location.search.split('=')[1];
        this.props.doLogin(token);
    }

    render(){
        const { user, authorized } = this.props;

        if(user && user.logado){
            return <Redirect to="/chat" />
        }
        if(authorized === false) {
            return <Redirect to="/403" />
        }
        return <ApplicationLoading />
    }
}

const mapStateToProps = ({login})=>{
    return {
        user : login.user,
        authorized: login.authorized
    }
};

const dispatchToProps = {
    doLogin: loginActions.doLogin
}

export default connect(mapStateToProps, dispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/components/login/Login.js